import AdminDashboard from "./AdminDashboard";
import EmployeeDashboard from "./EmployeeDashboard";
import StudentDashboard from "./StudentDashboard";
import GuardianDashboard from "./GuardianDashboard";
import { useUserState } from "../../context/UserContext";
import { getCurrentRole } from "../../data/roles";
import Permission from "../error/Permission";

const Dashboard = () => {
  const { userRole } = useUserState();
  const currentRole = getCurrentRole(userRole);

  return (
    currentRole === "admin" ? (<AdminDashboard />) : currentRole === "employee" ? <EmployeeDashboard /> :
      currentRole === "student" ? <StudentDashboard /> : currentRole === "guardian" ? <GuardianDashboard /> :
        <Permission />

  );
};

export default Dashboard;
